import {json, texture} from "p3";
import common from "../common";
import definitions from "../definitions";
import {iswebfont, locale} from "../utils";
import MenuScene from "./MenuScene";

export default class OutroScene extends MenuScene {
    constructor(questIndex=1) {
        super("outro_" + questIndex);

        this._questIndex = questIndex;
        this._frameHolder = null;
        this._imageHolder = null;
        this._frame = null;
        this._sequence = 
        [
            [
                {image:"outro_1_1", text:"", time:4},
                {image:"outro_1_2", text:locale("outro_1_2"), time:7, character_icon:"dialogue_icon_ivandoe"},
                {image:"outro_1_3", text:locale("outro_1_3"), time:7, character_icon:"dialogue_icon_queen_kristine"},
                {image:"outro_1_4", text:locale("outro_1_4"), time:7, character_icon:"dialogue_icon_ivandoe"},
                {image:"outro_1_5", text:locale("outro_1_5"), time:7, character_icon:"dialogue_icon_queen_kristine"},
                {image:"outro_1_6", text:locale("outro_1_6"), time:7, character_icon:"dialogue_icon_ivandoe"}
            ],
            [
                {image:"outro_2_1", text:locale("outro_2_1"), time:7, character_icon:"dialogue_icon_ivandoe"},
                {image:"outro_2_2", text:locale("outro_2_2"), time:7, character_icon:"dialogue_icon_nanny"},
                {image:"outro_2_3", text:locale("outro_2_3"), time:7, character_icon:"dialogue_icon_ivandoe"},
                {image:"outro_2_4", text:locale("outro_2_4"), time:7, character_icon:"dialogue_icon_nanny"},
                {image:"outro_2_5", text:locale("outro_2_5"), time:7, character_icon:"dialogue_icon_ivandoe"},
                {image:"outro_2_6", text:locale("outro_1_6"), time:7, character_icon:"dialogue_icon_ivandoe"}
            ],
            [
                {image:"outro_3_1", text:locale("outro_3_1"), time:7, character_icon:"dialogue_icon_ivandoe"},
                {image:"outro_3_2", text:locale("outro_3_2"), time:7, character_icon:"dialogue_icon_king_knut"},
                {image:"outro_3_3", text:locale("outro_3_3"), time:7, character_icon:"dialogue_icon_ivandoe"},
                {image:"outro_3_4", text:locale("outro_3_4"), time:7, character_icon:"dialogue_icon_king_knut"},
                {image:"outro_3_5", text:locale("outro_1_6"), time:7, character_icon:"dialogue_icon_ivandoe"}
            ]
        ];
        this._sequenceValue = 0;
        this._currentImage = null;
        this._nextButton = null;
        this._currentTime = 0;
        this._skipButton = null;

        this._music = null;
    }

    init() {
        super.init();
    }

    onSceneLoaded() {
        super.onSceneLoaded();

        this._backing = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._backing.tint = 0xf2e4cd;
        this._backing.width = common.STAGE_WIDTH;
        this._backing.height = common.STAGE_HEIGHT;
        this.addChild(this._backing);

        this._frameHolder = new PIXI.Container();
        this._frameHolder.x = common.STAGE_WIDTH / 2;
        this._frameHolder.y = (common.STAGE_HEIGHT / 2) - 60;
        this.addChild(this._frameHolder);

        this._imageHolder = new PIXI.Container();
        //this._imageHolder.scale.y = 600 / 512;
        this._frameHolder.addChild(this._imageHolder);

        this._imageHolder.mask = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._imageHolder.mask.tint = 0x000000;
        this._imageHolder.mask.anchor.set(0.5);
        this._imageHolder.mask.width = 1000;
        this._imageHolder.mask.height = 550;
        this._frameHolder.addChild(this._imageHolder.mask);

        this._frame = new PIXI.Container();
        this._frameHolder.addChild(this._frame);
        const left = new PIXI.Sprite(texture('outro_frame_l'));
        left.x = -1;
        left.anchor.set(1, 0.5);
        this._frame.addChild(left);
        const right = new PIXI.Sprite(texture('outro_frame_l'));
        right.x = 1;
        right.anchor.set(1, 0.5);
        right.scale.x = -1;
        this._frame.addChild(right);

        this._nextButton = P3.Button.create(
            texture("btn_small_out"),
            texture("btn_small_out"),
            texture("btn_small_out"),
            texture("btn_icon_next"),
        );
        this._nextButton.x = (common.STAGE_WIDTH/2) + (this._imageHolder.mask.width/2);
        this._nextButton.y = (common.STAGE_HEIGHT/2) + (this._imageHolder.mask.height/2);
        this._nextButton.signals.click.add(this.progressSequence, this);
        this.addChild(this._nextButton);

        this._skipButton = P3.Button.create(
            texture("btn_action_medium_out"),
            texture("btn_action_medium_out"),
            texture("btn_action_medium_out"),
            texture("btn_icon_skip_medium"),
        );
        this._skipButton.x = (common.STAGE_WIDTH/2) + (this._imageHolder.mask.width/2);
        this._skipButton.y = (common.STAGE_HEIGHT/2) + (this._imageHolder.mask.height/2);
        this._skipButton.signals.click.add(this._onSkip, this);
        this.addChild(this._skipButton);

        if (!iswebfont()) {
            this._text = new PIXI.BitmapText("", {
                fontName: "Alghera Pro",
                fontSize: 35,
                align: "center",
                tint: 0x000000,
                maxWidth: 780
            });
        } else {
            this._text = new PIXI.Text("", {
                fontFamily: "FredFredBurger",
                fontSize: 35,
                align: "center",
                fill: 0x0,
                wordWrap: true,
                wordWrapWidth: 780
            });
        }

        this._text.position.set(common.STAGE_WIDTH/2, (common.STAGE_HEIGHT/2) + (!iswebfont() ? 255 : 245));
        this._text.anchor.set(0.5, 0);
        this.addChild(this._text);

        this._characterIcon = new PIXI.Sprite(texture("dialogue_icon_ivandoe"));
        this._characterIcon.position.set(this._text.x, this._text.y);
        this._characterIcon.visible = false;
        this.addChild(this._characterIcon);

        if (!common.saveData.settings.musicMute) {
            this._introMusic = P3.audio.playSound("music_quest_outro_start");
        }

        this.addImage();

        this.resize();
    }

    addImage(){
        const image = new PIXI.Sprite(texture(this._sequence[this._questIndex-1][this._sequenceValue].image));
        image.anchor.set(0.5);
        this._imageHolder.addChild(image);

        image.position.set(
            ((image.width/2) - (this._imageHolder.mask.width/2)) * (Math.random() > 0.5 ? -1 : 1),
            ((image.height/2) - (this._imageHolder.mask.height/2)) * (Math.random() > 0.5 ? -1 : 1)
        );
        
        image.scale.set(1.0); // previously: 1.1
        this.addTween(gsap.to(image, 10, {x:image.x*-1, y:image.y*-1, ease:Linear.easeNone})); // previously: ease:Sine.easeInOut
        this.addTween(gsap.to(image.scale, 10, {x:1.03, y:1.03, ease:Linear.easeNone})); // previously: x:1, y: 1

        if (this._currentImage) {
            image.alpha = 0;
            this.addTween(gsap.to(image, 0.5, {alpha:1, onComplete:() => {
                this._imageHolder.removeChild(this._currentImage);
                this._currentImage = image;
            }}));
        } else {
            this._currentImage = image;
        }

        this._nextButton.visible = !(this._sequence[this._questIndex-1][this._sequenceValue].time);
        this._currentTime = 0;

        this._text.text = this._sequence[this._questIndex-1][this._sequenceValue].text;

        if (this._text.textWidth > 0) {
            this._characterIcon.texture = texture(this._sequence[this._questIndex-1][this._sequenceValue].character_icon);
            this._characterIcon.visible = true;
            this._characterIcon.position.set(this._text.x - this._text.textWidth / 2 - 100, this._text.y - 20);
        }
    }

    destroy() {
        this._nextButton.destroy();
        this._skipButton.destroy();
        this.removeAllTweens(true);
        super.destroy();
    }

    resize() {
        super.resize();

        if (this._skipButton) {
            this._skipButton.position.set(
                (common.STAGE_WIDTH + P3.View.width - this._skipButton.width) * 0.5 - 50,
                P3.View.height - this._skipButton.height * 0.5 - 50
            );
        }
    }

    update() {
        super.update();

        if (!!(this._sequence[this._questIndex-1][this._sequenceValue].time) && this._currentTime < this._sequence[this._questIndex-1][this._sequenceValue].time) {
            this._currentTime += window.dt;
            if (this._currentTime >= this._sequence[this._questIndex-1][this._sequenceValue].time) {
                this.progressSequence();
            }
        }

        if(this._introMusic && this._introMusic.howl == null) {
            //console.log('loop');
            this._introMusic = null;
            if (!common.saveData.settings.musicMute) {
                P3.audio.playMusic("music_quest_outro_loop");
            }
        }
    }

    _onSkip() {
        this.signals.next.dispatch();
    }

    progressSequence() {
        if (this._sequenceValue < this._sequence[this._questIndex-1].length-1) {
            this._sequenceValue ++;
            this.addImage();
            if(this._sequenceValue >= this._sequence[this._questIndex-1].length-1){
                P3.audio.stopMusic();
                if (!common.saveData.settings.musicMute) {
                    P3.audio.playSound("music_quest_outro_end");
                }
            }

        } else {
            this.signals.next.dispatch();
        }
    }

}

/**
 * @static
 * @type {OutroScene}
 */
OutroScene.active = null;